import { Link } from 'react-router-dom'
import { ModalShell } from '../../dashboard/admin/modals/ModalShell'
import type { SummaryPeriodClient } from '../../../shared/api/analytics.api'

function ClientColumn({
  title,
  clients,
  empty,
  onClose,
}: {
  title: string
  clients: SummaryPeriodClient[]
  empty: string
  onClose: () => void
}) {
  return (
    <div>
      <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
        {title}
      </div>
      {clients.length === 0 ? (
        <p className="text-sm text-gray-400 py-2">{empty}</p>
      ) : (
        <div className="divide-y divide-gray-100 rounded-xl border border-gray-100 max-h-80 overflow-y-auto">
          {clients.map((c) => (
            <Link
              key={c.clientId}
              to={`/clients/${c.clientId}`}
              onClick={onClose}
              className="block px-3 py-2 text-sm text-gray-900 truncate hover:bg-gray-50"
              title={c.name}
            >
              {c.name}
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}

/**
 * Модалка KPI-карточки «Новых клиентов»: клиенты когорты периода, разбитые на
 * новых (первая заявка в периоде) и вернувшихся. Клик по клиенту → карточка.
 */
export function SummaryPeriodClientsModal({
  clients,
  periodTitle,
  onClose,
}: {
  clients: SummaryPeriodClient[]
  periodTitle: string
  onClose: () => void
}) {
  const fresh = clients.filter((c) => c.isNew)
  const returning = clients.filter((c) => !c.isNew)
  return (
    <ModalShell
      title="Клиенты периода"
      subtitle={`${periodTitle} · по заявкам, созданным в периоде`}
      onClose={onClose}
      size="md"
    >
      <div className="grid sm:grid-cols-2 gap-4">
        <ClientColumn
          title={`Новые (${fresh.length})`}
          clients={fresh}
          empty="Новых клиентов нет"
          onClose={onClose}
        />
        <ClientColumn
          title={`Вернувшиеся (${returning.length})`}
          clients={returning}
          empty="Вернувшихся клиентов нет"
          onClose={onClose}
        />
      </div>
    </ModalShell>
  )
}
